<!--
 * @Author: zhangzhian
 * @Date: 2022-01-19 19:15:00
 * @LastEditors: zhangzhian
 * @LastEditTime: 2023-06-06 14:02:54
 * @FilePath: \dhr_frontend\src\components\AdvancedSearch\newAdvancedSearch.vue
 * @Description: 高级搜索组件
-->

<script lang="jsx">
import Bus from '@/utils/bus'
import _ from 'lodash'

export default {
  name: 'advancedSearch',
  props: {
    /**
     * 展示模式
     * popover: 弹出框模式
     * drawer: 抽屉模式
     */
    mode: {
      type: String,
      default: 'popover'
    },
    /**
     * 高级搜索绑定的参数对象，是实现 自动重置 和 高级搜索高亮 的关键
     */
    model: {
      type: Object,
    },
    /**
     * 是否在传入 model 后，在点击重置按钮后自动重置对象。
     */
    autoReset: {
      type: Boolean,
      default: true
    },
    /**
     * 自动重置和高亮所包含的字段，如果不传，则默认为 model 的所有字段
     */
    bindFormKeys: {
      type: Array,
    },
    /**
     * 高级搜索表单中不需要重置的字段
     */
    excludeFormKeys: {
      type: Array,
    },
    /**
     * 弹出框最大高度
     */
    popoverBoxMaxHeight: {
      type: String,
      default: '70vh'
    },
    /**
     * 是否隐藏红点
     */
    hiddenRedPoint: {
      type: Boolean,
      default: false
    },
    /**
     * 容器的属性，如 mode 为 popover 的 a-popover，drawer 的 a-drawer
     */
    contentAttr: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      activeFormKeyMap: {}
    };
  },
  computed: {
    btnActive() {
      return this.hiddenRedPoint ? false : Object.values(this.activeFormKeyMap).some(flag => flag)
    },
    usedKeys() {
      let keys = this.bindFormKeys || Object.keys(this.model)

      if (this.excludeFormKeys) {
        keys = keys.filter(key => !this.excludeFormKeys.includes(key))
      }

      return keys
    },
  },
  methods: {
    changeVis(close) {
      if (close && close === true) {
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    query() {
      /**
       * 点击搜索按钮时触发的查询事件
       */
      this.$emit('query');
      this.changeVis(true);
    },
    reset() {
      if (this.autoReset && this.formObjCache) {
        Object.assign(this.model, _.pick(_.cloneDeep(this.formObjCache), this.usedKeys))

        this.query();
      }

      /**
       * 点击重置按钮时触发的事件
       */
      this.$emit('reset');
      this.changeVis(true);
    },
    initFormWatcher() {
      if (!this.model) return

      // 缓存下最初的表单对象
      this.formObjCache = _.cloneDeep(this.model)

      this.usedKeys.forEach(key => {
        this.$watch(`model.${key}`, (val) => {
          if (typeof val === 'string') {
            this.$set(this.activeFormKeyMap, key, !!val)
          } if (typeof val === 'number') {
            this.$set(this.activeFormKeyMap, key, true)
          } else if (Array.isArray(val)) {
            // 兼容数组相同情况
            this.$set(this.activeFormKeyMap, key, (val.length > 0) && (JSON.stringify(this.model[key]) !== JSON.stringify(this.formObjCache[key])))
          } else if (val === undefined) {
            this.$set(this.activeFormKeyMap, key, false)
          }
        }, { immediate: true })
      })
    },
    renderPopoverMode() {
      const { popoverBoxMaxHeight, btnActive, changeVis, query, reset, contentAttr } = this;
      return (
        <a-popover
          v-model={this.visible}
          trigger="click"
          placement="left"
          overlayClassName="advanced_search_pop_div"
          {...contentAttr}
          onVisibleChange={() => {
            changeVis();
          }}
        >
          <div slot="content" class="advanced_search_pop_content_box">
            <div class="advanced_search_pop_content">
              <a-icon
                v-id="'advanced-search-close'"
                class="close-icon"
                type="close"
                onClick={() => this.changeVis(true)}
              />
              <div class="advanced_search_pop_title">搜索</div>
              <div
                class="form-content-box"
                style={`max-height: ${popoverBoxMaxHeight};`}
              >
                <div class="form-content-box__content">
                  {this.$scopedSlots.form ? this.$scopedSlots.form() : null}
                </div>
                <div class="form-content__btn-group">
                  <a-button v-id="'advanced-search-reset'" class="btn-group__btn btn-reset" onClick={reset}>
                    重置
                  </a-button>
                  <a-button
                    v-id="'advanced-search-query'"
                    class="btn-group__btn btn-query"
                    type="primary"
                    onClick={query}
                  >
                    搜索
                  </a-button>
                </div>
              </div>
            </div>
          </div>
          {this.$scopedSlots.default ? (
            this.$scopedSlots.default({ btnActive })
          ) : (
            <a-button v-id={'advanced-search'}>
              <div class={`${btnActive ? 'advanced-search__red-point' : ''}`}>高级查询</div>
            </a-button>
          )}
        </a-popover>
      );
    },
    renderDrawerMode() {
      const { popoverBoxMaxHeight, btnActive, changeVis, query, reset, visible, contentAttr } = this;

      return (
        <div class="advanced-search-drawer-root">
          <lin-drawer width="500px" title="搜索" attrs={contentAttr} visible={visible} onClose={() => changeVis(true)} maskClosable={true}>

            {this.$scopedSlots.form ? this.$scopedSlots.form() : null}

            <div slot="footer-right">
              <a-button size="large" style="width: 120px; right: 24px;" v-id="'advanced-search-reset'" onClick={reset}>重置</a-button>
              <a-button size="large" style="width: 120px;" type="primary" v-id="'advanced-search-query'" onClick={query}>搜索</a-button>
            </div>
          </lin-drawer>

          {this.$scopedSlots.default ? (
            this.$scopedSlots.default({ btnActive })
          ) : (
            <a-button v-id={'advanced-search'} onClick={() => changeVis()}>
              <div class={`${btnActive ? 'advanced-search__red-point' : ''}`}>高级查询</div>
            </a-button>
          )}
        </div>
      )
    }
  },
  mounted() {
    // 从事件总结监听关闭事件
    let closeHandle = () => {
      this.changeVis(true)
    }
    Bus.$on('advancedSearch:close', closeHandle)

    this.$on('hook:beforeDestroy', () => {
      Bus.$off('advancedSearch:close', closeHandle)
    })

    this.initFormWatcher()
  },
  render() {
    if (this.mode === 'drawer') {
      return this.renderDrawerMode()
    }
    return this.renderPopoverMode()
  }
};
</script>

<style lang="scss">
.advanced_search_pop_div {
  .advanced_search_pop_content_box {
    background: #ced6e4;
    width: fit-content;
    min-width: 356px;
    border-radius: 8px;
    padding: 16px;
    .advanced_search_pop_content {
      width: fit-content;
      min-width: 324px;
      background: #ffffff;
      border: 1px solid #f2f5fa;
      opacity: 1;
      border-radius: 8px;
      padding: 12px 16px;
      position: relative;
    }
    .close-icon {
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .advanced_search_pop_title {
      width: 56px;
      height: 28px;
      font-size: 28px;
      font-family: Source Han Sans;
      font-weight: bold;
      line-height: 48px;
      color: #11132a;
      opacity: 1;
      margin-bottom: 30px;
    }
    .form-content-box {
      position: relative;
      overflow-x: hidden;
      width: fit-content;
      min-width: 305px;
      display: flex;
      flex-direction: column;

      &__content {
        padding-right: 16px;
        flex: 1;
        overflow: auto;
      }
    }
    .form-content__btn-group {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;
      margin-bottom: 10px;
      .btn-group__btn {
        width: 128px;
        height: 40px;
        opacity: 1;
        border-radius: 4px;
      }
      .btn-reset {
        margin-right: 24px;
      }
      .btn-query {
        background: #00bfbf;
      }
    }
    .ant-form-item {
      margin-bottom: 5px;
    }
  }
  .hide-select-search {
    .ant-select-selection--multiple {
      cursor: pointer;
    }
    .ant-select-search__field {
      width: 0;
      cursor: pointer;
    }
  }
}
.advanced-search__red-point {
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: -3px;
    right: -12px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #f94e4e;
  }
}
</style>
